export default __webpack_public_path__ + "static/media/npsimple.245a40e9.png";